<template>
  <v-container fill-height>
    <v-row align="center" class="fill-height ma-0" justify="center">
      <ResHubLogo />
    </v-row>
  </v-container>
</template>

<script>
import ResHubLogo from "@/views/login/ResHubLogo.vue";
import { generatePkce } from "@/utils/pcsAuth/pkce";
import { getFunctionUrl, getPcsAuthorizeUrl } from "@/utils/pcsAuth/pcsAuthUrls";

export default {
  components: {
    ResHubLogo
  },
  data() {
    return {
      error: null,
      loading: false
    };
  },
  created() {
    this.startPcsLogin()
  },
  methods: {
    async startPcsLogin () {
     const { codeVerifier, codeChallenge, state } = await generatePkce();

      // Save codeVerifier to Firestore via backend
      const codeverifierFuncUrl = getFunctionUrl('pcs-codeverifier')
      await fetch(codeverifierFuncUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ state, codeVerifier }),
      });

      //Redirect to PCS Identity login
      const pcsAuthFuncUrl = getFunctionUrl('pcs-auth')
      const authUrl = new URL(getPcsAuthorizeUrl());
      authUrl.searchParams.set('client_id', 'ResHubCarePlan');
      authUrl.searchParams.set('response_type', 'code');
      authUrl.searchParams.set('redirect_uri', pcsAuthFuncUrl);
      authUrl.searchParams.set('scope', 'openid PCSClaim profile');
      authUrl.searchParams.set('code_challenge', codeChallenge);
      authUrl.searchParams.set('code_challenge_method', 'S256');
      authUrl.searchParams.set('state', state);

      window.location.href = authUrl.toString();
    }
  }
};
</script>
